import { render, staticRenderFns } from "./IncomeMortgage.vue?vue&type=template&id=1c7a9462"
import script from "./IncomeMortgage.vue?vue&type=script&lang=js"
export * from "./IncomeMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports